import * as angular from 'angular';
import carouselComponent from './carousel.component';
import CarouselService from './carousel.service';

export default angular
  .module('CarouselModule', [])
  .component('carousel', carouselComponent)
  .service('CarouselService', CarouselService)
  .name;



// WEBPACK FOOTER //
// ./src/app/shared/carousel/carousel.module.js